module.exports = __webpack_public_path__ + "img/lange_crub_5.0b34b573.jpg";